import { Spinner } from '@fluentui/react';
import { observer } from 'mobx-react';
import React from 'react';
import { IRootStateProps } from '../../state/RootState';
import DocumentViewer from '../controls/documents/DocumentViewer';

class StandaloneDocumentViewerTab extends React.Component<IRootStateProps> {
	render() {
		if (!this.props.RootState.standaloneDocViewerState) {
			return <Spinner />;
		}

		if (this.props.RootState.standaloneDocViewerState.docViewer) {
			return (
				<DocumentViewer
					state={this.props.RootState.standaloneDocViewerState?.docViewer}
				/>
			);
		} else {
			return (
				<>
					<Spinner />
				</>
			);
		}
	}
}

export default observer(StandaloneDocumentViewerTab);
